<template>
  <div class="thirdOut" :class="{ allComplete: isOrderEnd }">
    <!-- 完成 -->
    <div class="complete" v-if="isOrderEnd || progress > 3 || isAudit">
      <div class="completeTitle">
        <h3>{{ isOrderEnd ? "支付信息" : "上传缴费凭证" }}</h3>
      </div>

      <div v-if="(isOrderEnd && progress > 2) || !isOrderEnd">
        <div class="completeItem">
          <p @click="payTimeTip = !payTimeTip">
            支付时间<img
              src="./../../../../assets/decoration/order/tip.png"
              alt=""
            />
          </p>
          <span>{{ data.pay_time }}</span>
          <div class="payTimeTip" v-if="payTimeTip">
            支付时间为中介费和服务订金的最后一次打款时间。支付时间往向后顺延1个月为合同的服务开始时间，请正确输入。
            <img src="./../../../../assets/decoration/order/ysj.png" alt="" />
          </div>
        </div>
        <div class="completeImg" v-if="data.info && data.info.pay_thumbs">
          <div>
            <div class="completeItem">
              <p>服务订金</p>
              <span>{{ data.service_deposit_amount }}元</span>
            </div>
            <div class="completeImgin">
              <div
                v-for="(item, index) of data.info.pay_thumbs
                  .service_deposit_thumbs"
                :key="index"
              >
                <img
                  :src="item"
                  alt=""
                  @click="
                    comImgView(
                      data.info.pay_thumbs.service_deposit_thumbs,
                      item
                    )
                  "
                />
              </div>
              <span class="kb"></span><span class="kb"></span
              ><span class="kb"></span>
            </div>
          </div>
          <div>
            <div class="completeItem">
              <p>中介费</p>
              <span>{{ data.service_mediation_amount }}元</span>
            </div>
            <div class="completeImgin">
              <div
                v-for="(item, index) of data.info.pay_thumbs
                  .service_mediation_thumbs"
                :key="index"
              >
                <img
                  :src="item"
                  alt=""
                  @click="
                    comImgView(
                      data.info.pay_thumbs.service_mediation_thumbs,
                      item
                    )
                  "
                />
              </div>
              <span class="kb"></span><span class="kb"></span
              ><span class="kb"></span>
            </div>
          </div>
        </div>
        <!-- 标签 -->
        <img
          class="bq"
          v-if="isAudit && !isOrderEnd"
          src="./../../../../assets/decoration/order/shz.png"
        />
        <img
          v-if="!isAudit && !isOrderEnd"
          class="bq"
          src="./../../../../assets/decoration/order/ytg.png"
        />
      </div>
      <div v-if="isOrderEnd && progress < 3" class="notdata">
        <img src="./../../../../assets/decoration/order/noData.png" alt="" />
        <p>订单被终止，此项无数据</p>
      </div>
    </div>
    <!-- 驳回原因 -->
    <div class="rejectReason" v-if="isReject">
      <div>
        <p ref="detailDom" :class="{ unfold: isUnfold }">
          被驳回：{{ data.judge_remark }}
        </p>
      </div>
      <div class="tipMore" v-if="showDetailBtn">
        <span v-if="!isUnfold" @click="isUnfold = true"
          >展开<img src="./../../../../assets/decoration/moreBottom.png" alt=""
        /></span>
        <span v-if="isUnfold" @click="isUnfold = false"
          >关闭<img src="./../../../../assets/decoration/moreTop.png" alt=""
        /></span>
      </div>
    </div>
    <!-- 未完成 -->
    <div
      class="uncomplete"
      v-if="(!isOrderEnd || isReject) && progress == 3 && !isAudit"
    >
      <div class="uncompleteTop">
        <h3>上传缴费凭证</h3>
        <div class="item">
          <p>服务订金</p>
          <span>{{ data.service_deposit_amount }}元</span>
        </div>
        <div class="card" v-if="data.info && data.info.service_info">
          <div v-if="data.info.service_info.alipay_config">
            <p>服务订金收款支付宝账户信息：</p>
            <p>
              支付宝账号：<span>{{
                data.info.service_info.alipay_config.alipay_account
              }}</span>
            </p>
            <p>
              支付宝姓名:
              <span>{{
                data.info.service_info.alipay_config.alipay_name
              }}</span>
            </p>
          </div>
          <div v-if="data.info.service_info.bank_config">
            <p style="margin-top: 20px">服务订金收款银行卡账户信息：</p>
            <p>
              开户银行：<span>{{
                data.info.service_info.bank_config.account_bank
              }}</span>
            </p>
            <p>
              银行卡号：<span>{{
                data.info.service_info.bank_config.account_bank_number
              }}</span>
            </p>
            <p>
              开户人姓名：<span>{{
                data.info.service_info.bank_config.account_name
              }}</span>
            </p>
          </div>
          <img src="./../../../../assets/decoration/order/hsj.png" alt="" />
        </div>
        <div class="imgUplod">
          <div class="imgUplodTop">
            <p>服务订金缴费凭证</p>
            <span
              >请上传1～10张缴费凭证，格式jpg，jpeg，png ，大小控制在10M</span
            >
          </div>
          <div class="imgUplodBtm">
            <van-uploader
              v-model="fileList1"
              :max-count="10"
              accept="image/jpeg, image/jpg, image/png"
              multiple
              :max-size="10 * 1024 * 1024"
              :after-read="afterRead"
              :before-read="beforeRead"
              :preview-full-image="false"
              @oversize="onOversize"
              @click-preview="clickPreview($event, 1)"
            >
              <div class="box">
                <img src="./../../../../assets/decoration/order/addImg.png" />
              </div>
            </van-uploader>
          </div>
        </div>
        <div class="imgUplodTip" v-if="data.space_type == 3">
          <img src="./../../../../assets/decoration/tip.png" alt="" />
          <p>
            务必使用与认证资料主体同名的对公银行账户进行打款，否则会审核失败！
          </p>
        </div>
      </div>
      <div class="uncompleteMid">
        <div class="item">
          <p>中介费</p>
          <span>{{ data.service_mediation_amount }}元</span>
        </div>
        <div class="card" v-if="data.info && data.info.intermediary_info">
          <p>中介费收款银行卡账户信息：</p>
          <p>
            开户银行：<span>{{
              data.info.intermediary_info.bank_config.account_bank
            }}</span>
          </p>
          <p>
            银行卡号：<span>{{
              data.info.intermediary_info.bank_config.account_bank_number
            }}</span>
          </p>
          <p>
            开户人姓名：<span>{{
              data.info.intermediary_info.bank_config.account_name
            }}</span>
          </p>
          <img src="./../../../../assets/decoration/order/hsj.png" alt="" />
        </div>
        <div class="imgUplod">
          <div class="imgUplodTop">
            <p>中介费缴费凭证</p>
            <span
              >请上传1～5张缴费凭证，格式jpg，jpeg，png ，大小控制在10M</span
            >
          </div>
          <div class="imgUplodBtm">
            <van-uploader
              v-model="fileList2"
              :max-count="5"
              accept="image/jpeg, image/jpg, image/png"
              multiple
              :max-size="10 * 1024 * 1024"
              :after-read="afterRead"
              :before-read="beforeRead"
              :preview-full-image="false"
              @oversize="onOversize"
              @click-preview="clickPreview($event, 2)"
            >
              <div class="box">
                <img src="./../../../../assets/decoration/order/addImg.png" />
              </div>
            </van-uploader>
          </div>
        </div>
        <div class="imgUplodTip" v-if="data.space_type == 3">
          <img src="./../../../../assets/decoration/tip.png" alt="" />
          <p>
            务必使用与认证资料主体同名的对公银行账户进行打款，否则会审核失败！
          </p>
        </div>
      </div>
      <div class="uncompleteBtm">
        <div class="selectTime">
          <p>支付时间</p>
          <img
            @click="selectTimeTip = !selectTimeTip"
            src="./../../../../assets/decoration/order/tip.png"
            alt=""
          />
          <span
            @click="datetimePicker()"
            :style="{
              color: time ? '#333333' : '#CACDE0',
              fontWeight: time ? 'bold' : 'normal',
            }"
            >{{ time ? time : "请选择支付时间" }}</span
          >
          <img src="./../../../../assets/decoration/order/rl.png" alt="" />
        </div>
        <div class="selectTimeTip" v-if="selectTimeTip">
          支付时间为中介费和服务订金的最后一次打款时间。支付时间往向后顺延1个月为合同的服务开始时间，请正确输入。
          <img src="./../../../../assets/decoration/order/ysj.png" alt="" />
        </div>
      </div>
      <!-- 底部提交按钮 -->
      <div class="btmSubmit">
        <button @click="submit()">确认并提交</button>
      </div>
    </div>
    <van-action-sheet v-model="pickerShow" @close="closePicker()">
      <div class="pickerShowTop">
        <div>
          <span
            @click="switchDate(1)"
            :style="{
              borderBottom: pickerProgress == 1 ? '3px solid #5853E9' : 'none',
            }"
            >{{ nyrDate }}</span
          >
          <span
            @click="switchDate(2)"
            :style="{
              borderBottom: pickerProgress == 2 ? '3px solid #5853E9' : 'none',
            }"
            >{{ sfmDate }}</span
          >
        </div>
        <button @click="datetimePickerConfim()">确认</button>
      </div>
      <!-- 年月日 -->
      <div class="sheetNYR" v-if="pickerProgress == 1">
        <van-calendar
          :poppable="false"
          :show-confirm="false"
          :show-title="false"
          :show-subtitle="false"
          :min-date="minDate"
          :max-date="maxDate"
          :default-date="defaultDate"
          :row-height="44"
          color="#5853E9"
          :style="{ height: '350px' }"
          @select="selectNYR($event)"
        />
      </div>
      <!-- 时分秒 -->
      <div class="sheetSFM" v-if="pickerProgress == 2">
        <van-picker :columns="sfmColumns" @change="selectSFM" />
      </div>
    </van-action-sheet>
    <van-image-preview
      v-model="imagePreviewShow"
      :images="images"
      :start-position="activeIndex"
      @change="onChange"
    >
      <template v-slot:index>
        <div class="imagePreview">
          <span @click="imagePreviewShow = false"
            ><van-icon name="cross"
          /></span>
          <span>{{ index }}/{{ images.length }}</span>
          <span @click="deleteImg()"><van-icon name="delete-o" /></span>
        </div>
      </template>
    </van-image-preview>
  </div>
</template>
<script>
import Upload from "./../../../../providers/upload";
import { ImagePreview } from "vant";
export default {
  props: {
    progress: {
      default: 1,
    },
    id: {
      default: "",
    },
    isOrderEnd: {
      default: false,
    },
  },
  data() {
    return {
      fileList1: [], //服务订金缴费凭证
      fileList2: [], //中介费缴费凭证
      defaultDate: new Date(),
      nyrDate: "",
      sfmDate: "",
      time: "",
      pay_time: "",
      pickerShow: false,
      pickerProgress: 1,
      minDate: new Date("2022/01/01"),
      maxDate: new Date(),
      selectTimeTip: true,
      payTimeTip: false,
      sfmColumns: [
        // 第一列
        {
          values: [],
          defaultIndex: 0,
        },
        // 第二列
        {
          values: [],
          defaultIndex: 0,
        },
        // 第三列
        {
          values: [],
          defaultIndex: 0,
        },
      ],
      data: {},
      imagePreviewShow: false,
      images: [],
      index: 1,
      activeIndex: 0,
      activeImgList: 0,
      isAudit: false,
      isReject: false,
      isUnfold: false,
      showDetailBtn: false,
      detailDom: null,
    };
  },
  mounted() {
    this.sfmFormatting();
    this.getData();
    this.detailDom = this.$refs.detailDom;
  },
  methods: {
    showDetailBtnFun() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.detailDom = this.$refs.detailDom;
          //   console.log(this.detailDom);
          if (this.detailDom) {
            this.showDetailBtn =
              this.detailDom.clientHeight < this.detailDom.scrollHeight;
          }
        }, 100);
      });
    },
    getData() {
      this.$api
        .post("decoration/member/order/info", {
          order_id: this.id,
          scene: "payVoucher",
        })
        .then((res) => {
          this.data = res;
          //   判断当前状态
          this.isAudit = false;
          this.isReject = false;
          if (res.status == 20) {
            //   审核中
            this.isAudit = true;
          } else if (res.status == -30) {
            //   被驳回
            this.isReject = true;
            this.showDetailBtnFun();
            // 服务定金
            res.info.pay_thumbs.service_deposit_thumbs.forEach(
              (item, index) => {
                this.fileList1.push({ url: item });
              }
            );
            // 中介费
            res.info.pay_thumbs.service_mediation_thumbs.forEach(
              (item, index) => {
                this.fileList2.push({ url: item });
              }
            );
            // 支付时间
            // 设置时间选择器展示年月日
            this.nyrDate = `${res.pay_time.substring(
              0,
              4
            )}年${res.pay_time.substring(5, 7)}月${res.pay_time.substring(
              8,
              10
            )}日`;
            // 设置时间选择器展示时分秒
            this.sfmDate = res.pay_time.substring(
              res.pay_time.indexOf(" ") + 1
            );
            // 设置已选时间
            this.time = `${this.nyrDate} ${this.sfmDate}`;
            // 设置选择器选中时间
            this.defaultDate = new Date(
              res.pay_time
                .substring(0, res.pay_time.indexOf(" ") + 1)
                .replace(/-/g, "/")
            );
            // 设置后台时间
            this.pay_time = res.pay_time;
          }
        });
    },
    clickPreview(file, type) {
      this.activeImgList = type;
      this.images = [];
      switch (type) {
        case 1:
          //服务订金缴费凭证
          this.fileList1.forEach((item, index) => {
            this.images.push(item.url);
            if (file.url == item.url) {
              this.index = index + 1;
              this.activeIndex = index;
            }
          });
          break;
        case 2:
          //中介费缴费凭证
          this.fileList2.forEach((item, index) => {
            this.images.push(item.url);
            if (file.url == item.url) {
              this.index = index + 1;
              this.activeIndex = index;
            }
          });
          break;
        default:
      }
      if (this.images.length < 1) {
        this.imagePreviewShow = false;
      } else {
        this.imagePreviewShow = true;
      }
    },
    onChange(index) {
      this.index = index + 1;
    },
    deleteImg() {
      switch (this.activeImgList) {
        case 1:
          //服务订金缴费凭证
          this.fileList1.splice(this.activeIndex, 1);
          break;
        case 2:
          //中介费缴费凭证
          this.fileList2.splice(this.activeIndex, 1);
          break;
        default:
      }
      if (this.activeIndex > 0) {
        this.activeIndex = this.activeIndex - 1;
      } else {
        this.activeIndex = 0;
      }
      this.clickPreview("", this.activeImgList);
    },
    // 已完成图片预览
    comImgView(urls, url) {
      let imgs = [];
      let startPosition = 0;
      urls.forEach((item, index) => {
        imgs.push(item);
        if (item == url) {
          startPosition = index;
        }
      });
      ImagePreview({
        images: imgs,
        startPosition: startPosition,
        closeable: true,
        closeIconPosition: "top-left",
      });
    },
    //   时分秒格式化
    sfmFormatting() {
      for (let s = 0; s < 24; s++) {
        if (s < 10) {
          this.sfmColumns[0].values.push(`0${s}`);
        } else {
          this.sfmColumns[0].values.push(s);
        }
      }
      for (let j = 0; j < 60; j++) {
        if (j < 10) {
          this.sfmColumns[1].values.push(`0${j}`);
          this.sfmColumns[2].values.push(`0${j}`);
        } else {
          this.sfmColumns[1].values.push(j);
          this.sfmColumns[2].values.push(j);
        }
      }
    },
    // 获取当前时间
    getCurrentDate() {
      let currentDate = new Date();
      this.defaultDate = currentDate;
      this.nyrDate = `${currentDate.getFullYear()}年${
        currentDate.getMonth() + 1 > 9
          ? currentDate.getMonth() + 1
          : `0${currentDate.getMonth() + 1}`
      }月${
        currentDate.getDate() > 9
          ? currentDate.getDate()
          : `0${currentDate.getDate()}`
      }日`;
      let h =
        currentDate.getHours() > 9
          ? currentDate.getHours()
          : `0${currentDate.getHours()}`;
      let f =
        currentDate.getMinutes() > 9
          ? currentDate.getMinutes()
          : `0${currentDate.getMinutes()}`;
      let m =
        currentDate.getSeconds() > 9
          ? currentDate.getSeconds()
          : `0${currentDate.getSeconds()}`;
      this.sfmDate = `${h}:${f}:${m}`;
    },
    // 打开时间选择器
    datetimePicker() {
      if (this.pay_time) {
        this.switchDate(1);
      } else {
        this.getCurrentDate();
      }
      this.pickerProgress = 1;
      this.pickerShow = true;
    },
    // 关闭时间选择器
    closePicker() {
      this.pickerShow = false;
    },
    // 年月日 时分秒切换
    switchDate(type) {
      if (type == 1) {
        this.pickerProgress = 1;
        // defaultDate
      } else if (type == 2) {
        let activeH = this.sfmDate.substring(0, 2);
        let activeF = this.sfmDate.substring(3, 5);
        let activeM = this.sfmDate.substring(6, 8);
        this.sfmColumns[0].values.forEach((item, index) => {
          if (item == activeH) {
            this.sfmColumns[0].defaultIndex = index;
          }
        });
        this.sfmColumns[1].values.forEach((item, index) => {
          if (item == activeF) {
            this.sfmColumns[1].defaultIndex = index;
          }
        });
        this.sfmColumns[2].values.forEach((item, index) => {
          if (item == activeM) {
            this.sfmColumns[2].defaultIndex = index;
          }
        });
        this.pickerProgress = 2;
      }
    },
    // 年月日选择
    selectNYR(e) {
      this.nyrDate = `${e.getFullYear()}年${
        e.getMonth() + 1 > 9 ? e.getMonth() + 1 : `0${e.getMonth() + 1}`
      }月${e.getDate() > 9 ? e.getDate() : `0${e.getDate()}`}日`;
      this.defaultDate = e;
    },
    // 时分秒选择
    selectSFM(value, index) {
      this.sfmDate = `${index[0]}:${index[1]}:${index[2]}`;
    },
    // 确定选中日期
    datetimePickerConfim() {
      this.time = `${this.nyrDate} ${this.sfmDate}`;
      let nian = this.nyrDate.substring(0, this.nyrDate.indexOf("年"));
      let yue = this.nyrDate.substring(
        this.nyrDate.indexOf("年") + 1,
        this.nyrDate.indexOf("月")
      );
      let ri = this.nyrDate.substring(
        this.nyrDate.indexOf("月") + 1,
        this.nyrDate.indexOf("日")
      );
      this.pay_time = `${nian}-${yue}-${ri} ${this.sfmDate}`;
      this.closePicker();
    },
    beforeRead(file) {
      if (file.size == 0 || JSON.stringify(file.file) == "{}") {
        //解决部分机型取消上传还是添加空白图片
        return false;
      } else {
        return true;
      }
    },
    afterRead(file) {
      if (Array.isArray(file)) {
        // 多选
        file.forEach((item) => {
          this.imgUpload(item);
        });
      } else {
        // 单选
        this.imgUpload(file);
      }
    },
    onOversize(file) {
      this.$toast("上传文件大小请控制在10M内");
    },
    // 图片上传
    imgUpload(file) {
      file.status = "uploading";
      file.message = "上传中...";
      Upload.upload(file.file, ["others"])
        .then((res) => {
          file.status = "";
          file.message = "";
          file.url = res;
        })
        .catch((res) => {
          file.status = "failed";
          file.message = "失败";
        });
    },
    submit() {
      let service_deposit_thumbs_end = true;
      let service_mediation_thumbs_end = true;
      let service_deposit_thumbs = []; //类型：Array  必有字段  备注：服务定金fileList1
      let service_mediation_thumbs = []; //类型：Array  必有字段  备注：中介费fileList2
      this.fileList1.forEach((item) => {
        if (item.url) {
          service_deposit_thumbs.push(item.url);
        } else {
          this.$toast("图片正在上传中，请稍等");
          service_deposit_thumbs_end = false;
          return;
        }
      });
      this.fileList2.forEach((item) => {
        if (item.url) {
          service_mediation_thumbs.push(item.url);
        } else {
          this.$toast("图片正在上传中，请稍等");
          service_mediation_thumbs_end = false;
          return;
        }
      });
      if (!service_deposit_thumbs_end || !service_mediation_thumbs_end) {
        return;
      }
      this.$api.get("decoration/basic/csrf/token").then((res) => {
        this.$api
          .post("decoration/member/order/submit/pay/voucher", {
            order_id: this.id,
            csrf_token: res.csrf_token,
            pay_time: this.pay_time, //类型：String  必有字段  备注：支付时间
            service_deposit_thumbs: service_deposit_thumbs, //类型：Array  必有字段  备注：服务定金
            service_mediation_thumbs: service_mediation_thumbs, //类型：Array  必有字段  备注：中介费
          })
          .then((rer) => {
            this.getData();
            this.$emit("nextStep");
          })
          .catch((err) => {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
            return;
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.thirdOut {
  .complete {
    // background-color: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: relative;
    margin: 12px 16px;
    .completeTitle {
      background-color: #ffffff;
      padding: 31px 24px 0px;
      h3 {
        display: inline-block;
        font-size: 16px;
        font-weight: 700;
        color: #333333;
        border-bottom: 5px solid #d2c3ff;
        margin: 0 0 8px;
        height: 16px;
        align-self: flex-start;
      }
    }
    .completeItem {
      padding: 16px 28px 0;
      display: flex;
      justify-content: space-between;
      font-size: 15px;
      position: relative;
      background-color: #ffffff;
      p {
        color: #999999;
        flex-shrink: 0;
        margin-right: 25px;
        display: flex;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
        }
      }
      span {
        color: #333333;
        text-align: right;
      }
      .payTimeTip {
        position: absolute;
        top: 44px;
        left: 0;
        padding: 10px 12px;
        font-size: 13px;
        color: #ff7e31;
        line-height: 18px;
        background: #ffdecb;
        border-radius: 6px;
        z-index: 1;
        margin: 0 24px;
        img {
          width: 23px;
          height: 10px;
          position: absolute;
          top: -10px;
          left: 60px;
        }
      }
    }
    .completeImg {
      > div {
        margin-top: 1px;
        .completeImgin {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          padding: 9px 28px 24px;
          background-color: #ffffff;
          > div {
            width: 18.7%;
            height: 54px;
            border-radius: 4px;
            border: 1px solid #cacde0;
            margin-top: 3px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .kb {
            width: 18.7%;
          }
        }
      }
      > div:first-child {
        margin: 0;
      }
    }
    .bq {
      width: 68px;
      height: 68px;
      position: absolute;
      top: 7px;
      right: 15px;
    }
    .notdata {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;
      padding: 32px 0 30px;
      img {
        width: 101px;
        height: 85px;
      }
      p {
        font-size: 13px;
        color: #999999;
        margin-top: 7px;
      }
    }
  }
  //   驳回原因
  .rejectReason {
    padding: 10px 16px;
    background-color: #ffdbc6;
    color: #ff7e31;
    p {
      font-size: 14px;
      margin-right: 10px;
      // border: 1px solid red;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      white-space: normal;
      word-break: break-all;
      word-wrap: break-word;
      text-align: justify;
      line-height: 24px;
    }
    .unfold {
      -webkit-line-clamp: 99;
    }
    .tipMore {
      display: flex;
      // justify-content: flex-end;
      span {
        font-size: 14px;
        display: flex;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
  .uncomplete {
    padding-bottom: 95px;
    margin: 12px 16px;
    .uncompleteTop {
      background-color: #ffffff;
      border-radius: 12px;
      padding: 20px 12px 24px;
      h3 {
        display: inline-block;
        font-size: 20px;
        font-weight: 700;
        color: #333333;
        border-bottom: 5px solid #d2c3ff;
        margin: 0 12px 16px;
        height: 20px;
        align-self: flex-start;
      }
    }
    .uncompleteMid {
      background-color: #ffffff;
      border-radius: 12px;
      padding: 1px 12px 24px;
      margin-top: 6px;
    }
    .uncompleteBtm {
      background-color: #ffffff;
      border-radius: 12px;
      padding: 24px 12px 24px;
      margin-top: 6px;
      .selectTime {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666666;
        padding: 10px 16px;
        background-color: #f7f8ff;
        border-radius: 6px;
        p {
        }
        span {
          flex: 1;
          margin: 0 8px;
          font-weight: bold;
        }
        img {
          width: 16px;
          height: 16px;
        }
      }
      .selectTimeTip {
        padding: 10px 12px;
        font-size: 13px;
        color: #ff7e31;
        line-height: 18px;
        background: #ffdecb;
        border-radius: 6px;
        position: relative;
        margin-top: 5px;
        img {
          width: 23px;
          height: 10px;
          position: absolute;
          top: -10px;
          left: 69px;
        }
      }
    }
    .btmSubmit {
      width: 100%;
      height: 83px;
      position: fixed;
      left: 0;
      bottom: 0;
      background-color: #ffffff;
      display: flex;
      box-shadow: inset 0px 1px 0px 0px #f7f8fc;
      button {
        height: 46px;
        flex: 1;
        margin: 2px 16px;
        border: none;
        background: #5853e9;
        border-radius: 25px;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
      }
    }
    .item {
      display: flex;
      justify-content: space-between;
      height: 20px;
      font-size: 14px;
      color: #333333;
      margin: 32px 12px 0;
      span {
        font-weight: 700;
      }
    }
    .card {
      background: #f7f8ff;
      border-radius: 8px;
      margin-top: 16px;
      padding: 12px 22px;
      position: relative;
      p {
        font-size: 13px;
        color: #666666;
        line-height: 22px;
        span {
          font-weight: bold;
        }
      }
      img {
        width: 28px;
        height: 14px;
        position: absolute;
        top: -14px;
        left: 34px;
      }
    }
    .imgUplod {
      margin-top: 25px;
      .imgUplodTop {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        p {
          flex-shrink: 0;
          margin-right: 12px;
        }
        span {
          color: #999999;
          font-size: 12px;
        }
      }
      .imgUplodBtm {
        display: flex;
        margin-top: 16px;
        img {
          width: 60px;
          height: 60px;
        }
        ::v-deep .van-uploader__preview {
          margin: 0 3px 4px 0;
        }
        ::v-deep .van-uploader__preview-image,
        ::v-deep .van-uploader__file {
          width: 60px;
          height: 60px;
        }
      }
    }
    .imgUplodTip {
      margin-top: 16px;
      background: #faf6f1;
      border-radius: 4px;
      display: flex;
      padding: 6px;
      img {
        width: 12px;
        height: 12px;
        margin: 2px 5px 0 0;
      }
      p {
        font-size: 12px;
        color: #c38e58;
        line-height: 17px;
      }
    }
  }
  .pickerShowTop {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: inset 0px -9px 10px -16px #000;
    div {
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        height: 100%;
        padding: 0 16px;
        font-size: 14px;
        color: #969799;
        line-height: 41px;
      }
    }
    button {
      color: #5853e9;
      height: 100%;
      padding: 0 16px;
      font-size: 14px;
      border: none;
      background-color: transparent;
    }
  }
  .sheetNYR,
  .sheetSFM {
    height: 350px;
    display: flex;
    align-items: center;
    .van-picker {
      flex: 1;
    }
  }
  ::v-deep .van-image-preview__index {
    width: 100%;
  }
  .imagePreview {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 24px;
    span {
      background-color: rgba(255, 255, 255, 0.2);
      padding: 4px 12px;
      border-radius: 15px;
    }
    span:first-child,
    span:last-child {
      padding: 4px 8px;
    }
  }
}
.allComplete {
  margin: 0;
  .complete {
    border-radius: 0;
    margin: 0;
  }
}
</style>
